<template>
    <div>方案选择</div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>